module.exports = __webpack_public_path__ + "static/media/tope_pvc.91449688.jpg";